/**
 * The drawn window is laid out at the site's real desktop sizes, then zoomed the
 * way a product screenshot is shown scaled, so the ringed item stays in view
 * beside the text while the rest of the window runs off the right edge.
 * (No backticks in this file: it is one template literal.)
 */
export const HERO_UI_CSS = `
@media (min-width:1024px){.hero-zoom{zoom:.6;}}
@media (min-width:1280px){.hero-zoom{zoom:.72;}}
@media (min-width:1440px){.hero-zoom{zoom:.88;}}
`;
